<template>
  <button :title="messages['uploadFileDescription']"
          class="btn btn-sm btn-outline-primary mx-1 mr-1"
          v-on:click="triggerUploaderClick()">{{ messages['uploadFile'] }}
    <!--suppress HtmlUnknownTag -->
    <form enctype="multipart/form-data" method="POST">
      <input
        accept="application/msword,.doc,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.docx"
        hidden="hidden"
        name="filename" type="file"/>
    </form>
  </button>
</template>

<!--suppress JSUnusedGlobalSymbols -->
<script>
import axios from 'axios'

export default {
  name: 'TemplateUploaderButton',
  props: [
    'messages',
    'templateId',
    'path'
  ],
  data () {
    const uploader = null

    return {
      uploader
    }
  },
  mounted () {
    const self = this
    const inputs = this.$el.getElementsByTagName('input')
    if (inputs.length > 0) {
      this.uploader = inputs[0]
      this.uploader.addEventListener('change', function () {
        self.fileUploaderInputChange()
      })
    }
  },
  methods: {
    triggerUploaderClick () {
      if (this.uploader == null) {
        return
      }
      this.hasError = false

      // noinspection JSUnresolvedFunction
      this.uploader.click()
    },
    fileUploaderInputChange () {
      if (this.uploader == null) {
        return
      }

      // noinspection JSUnresolvedVariable
      const files = this.uploader.files
      if (files.length === 0) {
        return
      }

      const formData = new FormData()
      for (let i = 0; i < files.length; i++) {
        const file = files[i]
        formData.append('files', file)
      }
      formData.append('templateId', this.templateId)
      formData.append('path', this.path)

      const config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }

      axios.post('/rest/v1/templates', formData, config).then(_ => {
        setInterval(function () {
          document.location.reload()
        }, 200)
      }, _ => {
        setInterval(function () {
          document.location.reload()
        }, 200)
      })

      this.uploader.value = ''
    }
  }
}
</script>
